// extracted by mini-css-extract-plugin
export default {"header-flex-group":"WeatherCardHeaderContent_header-flex-group__DJCpF"};